import { createBrowserHistory, createMemoryHistory } from "history";
import { env } from "next-runtime-env";

export const history =
  typeof window === "undefined"
    ? createMemoryHistory({})
    : createBrowserHistory({ basename: env("NEXT_PUBLIC_BASENAME") });
